import { pureJsCrypto } from './js.js'

export const defaultCrypto = pureJsCrypto
